import React from "react";
export const QueryBuilderContext = React.createContext(null);
